
import React from 'react';

interface LogoProps {
  size?: 'small' | 'medium' | 'large';
  showText?: boolean;
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ 
  size = 'medium', 
  showText = true, 
  className = '' 
}) => {
  const sizeClasses = {
    small: 'h-8',
    medium: 'h-10',
    large: 'h-12'
  };

  const textSizeClasses = {
    small: 'text-lg',
    medium: 'text-xl',
    large: 'text-2xl'
  };

  return (
    <div className={`flex items-center ${className}`}>
      <img 
        src="/resources/8a09905390e18db17c078373047ab744.png"
        alt="Koluno Logo"
        className={`${sizeClasses[size]} w-auto object-contain`}
      />
      {showText && (
        <span className={`ml-2 font-bold text-gray-900 ${textSizeClasses[size]}`}>
          Koluno
        </span>
      )}
    </div>
  );
};

export default Logo;
